import { FC } from 'react';
import { Button, Grid, makeStyles } from '@material-ui/core';
import { FormikProps } from 'formik';
import ControlledFormFormik, { Props as ControlledFormFormikProps } from './ControlledFormFormik';
import GridLayout, { Header, Actions, Row } from './GridLayout';
import AlertMessage from '../controls/helpers/AlertMessage';
import { useSharedStyles } from '../../common/sharedStyles';
import { ReactComponent as LogoImage } from '../../images/nz-funds-nz-logo.svg';
import { Colors } from '../controls/helpers';

interface Props {
    title?: string;
    hidePrev?: boolean;
    hideNext?: boolean;
    nextLabel?: string;
    FormProps?: ControlledFormFormikProps;
    submitFailed?: boolean;
    onBack?: () => unknown;
    screenLocked?: boolean;
}

const QuestionnaireView: FC<Props> = ({ children, title, hidePrev, hideNext, nextLabel, FormProps, submitFailed, onBack, screenLocked }) => {
    const classes = useStyles();
    const sharedClasses = useSharedStyles();

    return <ControlledFormFormik {...FormProps} className={sharedClasses.form}>
        {(formik: FormikProps<any>) =>
            <GridLayout isNarrowView>
                <Header isNarrowView>
                    <Grid container alignItems="center">
                        <LogoImage width={36} height={36} fill={Colors.Black} />&emsp;&emsp;
                        {title || '\xa0'}
                    </Grid>
                </Header>
                {submitFailed &&
                    <Row isNarrowView>
                        <AlertMessage error message="An unexpected error has occurred. Please try again later." />
                    </Row>
                }
                {typeof children === 'function' ? children(formik) : children}
                <Actions isNarrowView className={hidePrev && hideNext && classes.hideFooter || ''}>
                    {!hidePrev && <Button variant="contained" onClick={onBack} disabled={screenLocked} key={`prev${!formik.isValid || screenLocked}`}>Previous</Button>}
                    {!hideNext && <Button color="primary" variant="contained" type="submit" className={classes.btnNext} disabled={!formik.isValid || screenLocked} key={`${!formik.isValid || screenLocked}`}>{nextLabel ?? 'Next'}</Button>}
                </Actions>
            </GridLayout>
        }
    </ControlledFormFormik>
}

const useStyles = makeStyles({
    hideFooter: {
        minHeight: '0px !important',
        padding: '0 !important'       
    },
    btnNext: {
        marginLeft: 'auto'
    }
}, { name: 'QuestionnaireView' });

export default QuestionnaireView;
